import { useEffect, useState } from 'react'

/** `value`, but only once it has stopped changing for `ms`. For search-as-you-type. */
export function useDebounced<T>(value: T, ms = 150): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms)
    return () => clearTimeout(timer)
  }, [value, ms])
  return settled
}
